import React, { Fragment } from "react";
import { TextProps } from "@/types/ui-kit/ui";
import parse from "html-react-parser";

export const Text: React.FC<TextProps> = ({ children }) => {
  return (children && <Fragment>{parse(`${children}`)}</Fragment>) || null;
};
